import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";

export const postOrganizationDocument = (organizationId, documentId, organizationDocument) => {
  return dispatch => {
    //dispatch({ type: "MODIFY_ORGANIZATION_DOCUMENT_LOADING" });
    api
      .organizationDocumentPost(organizationId, documentId, organizationDocument)
      .then(resp => {
        if (resp.documentId) {
          dispatch(postEditSucceeded(resp.data));
        } else {
          dispatch(postNewSucceeded(resp.data));
        }
      })
      .catch(e => {
        jsError(e);

          const status = e.response?.status;

        //New rule error (duplicate category)
        if (status === 409) {
          dispatch(
            buildAlertWithLocalizedMessages(
              "WARNING",
              "DuplicateOrganizationDocumentAlert",
              "Kategoria on jo käytössä. Et voi lisätä useampaa dokumenttia samaan kategoriaan."
            )
          );

          dispatch(operationFail());
          return;
        }

        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "ModifyOrganizationDocumentErrorAlertTitle",
          "Virhe yrityksen dokumentin muuttamisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const postEditSucceeded = data => ({
  type: "POST_ORGANIZATION_DOCUMENT_EDIT_SUCCEEDED",
  payload: { organizationDocument: data },
});

const postNewSucceeded = data => ({
  type: "POST_ORGANIZATION_DOCUMENT_SUCCEEDED",
  payload: { organizationDocument: data },
});

const operationFail = () => ({
  type: "MODIFY_ORGANIZATION_DOCUMENT_FAIL"
});
